import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchAvailabilityRequest } from '../actionCreators/availability/availabilityActionCreators'

class AvailabilityDataLayer extends Component {
  componentDidMount = () => {
    const { partNumbers, requestAvailability } = this.props
    requestAvailability(partNumbers)
  }

  render = () => {
    const { children } = this.props
    return children
  }
}

AvailabilityDataLayer.propTypes = {
  partNumbers: PropTypes.array.isRequired
}

export default connect((state, props) => props, { requestAvailability: fetchAvailabilityRequest })(
  AvailabilityDataLayer
)
export { AvailabilityDataLayer }
